import { useMemo } from 'react';

const COLORS = ['#FF6B00', '#D4AF37', '#F5D76E', '#800000', '#FF9500', '#FFD700'];
const SHAPES = ['circle', 'rect', 'triangle'];

function randomBetween(a, b) {
  return a + Math.random() * (b - a);
}

export default function Confetti({ active }) {
  const particles = useMemo(() => {
    return Array.from({ length: 48 }, (_, i) => ({
      id: i,
      x: `${randomBetween(5, 95)}vw`,
      size: `${randomBetween(6, 14)}px`,
      color: COLORS[i % COLORS.length],
      shape: SHAPES[i % SHAPES.length],
      duration: `${randomBetween(1.8, 3.2)}s`,
      delay: `${randomBetween(0, 0.6)}s`,
      xDrift: `${randomBetween(-60, 60)}px`,
      rotation: `${randomBetween(0, 360)}deg`,
      rotSpeed: `${randomBetween(180, 720)}deg`,
    }));
  }, []);

  if (!active) return null;

  return (
    <div className="confetti-container" aria-hidden>
      {particles.map(p => (
        <div
          key={p.id}
          className="confetti-particle"
          style={{
            '--x': p.x,
            '--size': p.size,
            '--duration': p.duration,
            '--delay': p.delay,
            '--xDrift': p.xDrift,
            '--rotation': p.rotation,
            '--rotSpeed': p.rotSpeed,
            width: p.size,
            height: p.size,
            background: p.shape !== 'triangle' ? p.color : 'transparent',
            borderRadius: p.shape === 'circle' ? '50%' : p.shape === 'rect' ? '2px' : 0,
            borderLeft: p.shape === 'triangle' ? `${parseFloat(p.size) / 2}px solid transparent` : undefined,
            borderRight: p.shape === 'triangle' ? `${parseFloat(p.size) / 2}px solid transparent` : undefined,
            borderBottom: p.shape === 'triangle' ? `${p.size} solid ${p.color}` : undefined,
          }}
        />
      ))}
    </div>
  );
}
